import { Project, MaintenanceEvents, MaintenanceEvent } from '@leverege/api-redux'
import { Pane } from '@leverege/ui-elements'
import React from 'react'
import { Route } from 'react-router-dom'
import { BreadcrumbActions } from '../../actions'
import MaintenanceEventGroupScreen from './MaintenanceEventGroupScreen'

export default class MaintenanceEventHomeScreen extends React.Component {
  constructor( props ) {
    super( props )
    const { match : { params : { projectId } } } = props
    this.projectId = projectId
  }

  updateBreadcrumbs( id ) {
    const { dispatch } = this.props
    if ( id ) {
      dispatch( BreadcrumbActions.setBreadcrumbs( [
        { name : 'Maintenance Events',
          link : `/project/${this.projectId}/maintenanceEvent` },
        { name : id }
      ] ) )
    } else {
      dispatch( BreadcrumbActions.setBreadcrumbs( [
        { name : 'Maintenance Events' }
      ] ) )
    }
  }

  onSelect = ( { data : id } ) => {
    const { history, match } = this.props
    this.updateBreadcrumbs( id )
    history.push( `/project/${match.params.projectId}/maintenanceEvent/${id}` )
  }

  render() {
    const baseActions = new Project( this.projectId )

    return (
      <Pane style={{ height : '100%', overflow : 'hidden' }} variant="view">
        <Route
          key="/project/:projectId/maintenanceEvent"
          exact
          path={[
            '/project/:projectId/maintenanceEvent',
            '/maintenanceEvent'
          ]}
          render={( { location } ) => {
            const groupActions = location.pathname === '/maintenanceEvents' ?
              new MaintenanceEvents() :
              baseActions.maintenanceEvents()
            return (
              <MaintenanceEventGroupScreen
                projectId={this.projectId}
                onSelect={this.onSelect}
                actions={groupActions}
                itemActions={id => ( location.pathname === '/maintenanceEvents' ?
                  new MaintenanceEvent( undefined, id ) :
                  baseActions.maintenanceEvent( id ) )} />
            )
          }} />
      </Pane>
    )
  }
}
